import { Template } from "features/Influencer/ContactList/schema";

import {
  GamificationProfile,
  OrganizationGamificationCredit,
  OrganizationGamificationTask,
} from "./schema";

export const hasTaskByType = (
  gamificationProfile: GamificationProfile | null,
  taskType: OrganizationGamificationTask,
) => {
  if (!gamificationProfile || !gamificationProfile?.tasksCompleted)
    return false;
  return gamificationProfile.tasksCompleted?.some((task) => task === taskType);
};

export const countTaskByType = (
  gamificationProfile: GamificationProfile | null,
  taskType: OrganizationGamificationTask,
) => {
  if (!gamificationProfile || !gamificationProfile?.tasksCompleted) return 0;
  return gamificationProfile.tasksCompleted.filter((task) => task === taskType)
    .length;
};

export const countCreditByTask = (
  credits: OrganizationGamificationCredit[] | null,
  taskType: OrganizationGamificationTask,
) => {
  if (!credits) return 0;
  return credits.filter((task) => task.transactionType === taskType).length;
};

export const displayFirstTemplateCard = (
  outreachTemplates: Template[],
  gamificationProfile: GamificationProfile,
) => {
  const sortedTemplatesByCreatedAt = outreachTemplates?.sort((a, b) => {
    if (!a.createdAt || !b.createdAt) return 0;
    return a.createdAt - b.createdAt;
  });

  const secondTemplate = sortedTemplatesByCreatedAt?.[1];
  if (
    !secondTemplate ||
    !secondTemplate?.createdAt ||
    !gamificationProfile ||
    !gamificationProfile?.createdAt
  )
    return false;
  return secondTemplate?.createdAt >= gamificationProfile?.createdAt;
};
